// utils/getRecaptchaToken.js // note that we are using enterprise version of google-reCAPTCHA
const SECRET = process.env.REACT_APP_RECAPTHA_SITEKEY; // sitekey for google-reCAPTCHA
// const SECRET = "6LdOZYQrAAAAAK7vAitWVV7ozi44U4YZ5NaRI_s3"; // sitekey for google-reCAPTCHA
// console.log("SECRET => ", SECRET)

export const getEnterpriseRecaptchaToken = async (action = 'submit') => {
  // console.log('🔵 Starting reCAPTCHA token generation');
  try {

    if (!window.grecaptcha?.enterprise) {
      console.error('❌ reCAPTCHA not loaded or enterprise not available');
      return null;
    }
    return new Promise((resolve, reject) => {
      // console.log('🔵 Setting up reCAPTCHA promise');
      window.grecaptcha.enterprise.ready(() => {
        // console.log('🔵 reCAPTCHA ready, executing...');
        window.grecaptcha.enterprise.execute(SECRET, { action })
        .then(token => {
          // console.log('✅ reCAPTCHA token received:', token ? 'SUCCESS' : 'EMPTY');
          resolve(token);
        })
        .catch(error => {
          console.error('❌ reCAPTCHA execution failed:', error);
          reject(error);
        });
      });
    });
  } catch (error) {
   console.error("reCAPTCHA error:", error || "Unknown error");
}
};